import { render } from "./fenpeizhanghao.vue?vue&type=template&id=75d3cee4&scoped=true"
import script from "./fenpeizhanghao.vue?vue&type=script&lang=js"
export * from "./fenpeizhanghao.vue?vue&type=script&lang=js"

import "./fenpeizhanghao.vue?vue&type=style&index=0&id=75d3cee4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d3cee4"]])

export default __exports__